import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectCustomerData = state => selectState(state).data;
export const selectCustomerLoading = state => selectState(state).loading;
export const selectCustomerError = state => selectState(state).error;
